// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import EligibleController from "./eligible_controller"
application.register("eligible", EligibleController)

import PhoneMaskController from "./phone_mask_controller"
application.register("phone-mask", PhoneMaskController)
